import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import SettingInformationEdit_TJ360VersionDevice from '../polling/pollingTopicDetails_TJ360VersionDevice/SettingInformationEdit_TJ360VersionDevice';

export type SelectSettingInformationDialog_TJ360DeviceVersonProps = {
    isOpen: boolean;
    onOK: (data: any) => void;
    onCancel: () => void;
    data: any;
    dialogTitle: string;
};

export const SelectSettingInformationDialog_TJ360DeviceVerson = (props: SelectSettingInformationDialog_TJ360DeviceVersonProps) => {
    const { isOpen, onOK, onCancel, data, dialogTitle } = props;
    const [open, setOpen] = React.useState(isOpen);

    // Cancelボタンイベント
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };

    const handleUpdate = (data: any) => {
        setOpen(false);
        onOK(data);
    };

    return (
        <div>
            <Dialog open={open} maxWidth={"md"} fullWidth>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent sx={{ pb: 1.5 }}>
                    <SettingInformationEdit_TJ360VersionDevice onCancel={handleCancel} settingInformation={data} onOK={(data) => handleUpdate(data)}></SettingInformationEdit_TJ360VersionDevice>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default SelectSettingInformationDialog_TJ360DeviceVerson;